import CustomFile from "../utils/customFile";
import {
    renameJobAdderSelects,
    setupJobAdderSelects,
    handleJobAdderScroll
} from '../utils/jobAdderHelpers';

export default class JobsPortal {
    constructor(query) {
        this.el = document.querySelector(query);
        if (!this.el) return;

        this.customFile = new CustomFile(this.el);

        this.init();
    }

    init() {
        this.observer = new MutationObserver(() => {
            this.setupLoader();

            this.setupKeywordSearch();
            this.setupPager();
            this.setupJobSectors();
            this.setupApplicationFile();

            renameJobAdderSelects(this.el);
            setupJobAdderSelects(this.el);
            handleJobAdderScroll(this.el);
        });

        this.observer.observe(this.el, {
            childList: true,
            subtree: true,
        });
    }

    setupSelects(selects) {
        selects.forEach((select) => {
            if (select.dataset.jobsPortalSelectReady) return;

            select.dataset.jobsPortalSelectReady = 'true';

            const source = select.parentNode;
            const options = [...select.options];

            if (!source || !options.length) return;

            const customSelect = document.createElement('div');
            customSelect.className = 'jobs-portal-select';

            const trigger = document.createElement('div');
            trigger.className = 'jobs-portal-select__trigger';
            trigger.textContent = select.options[select.selectedIndex].textContent;
            trigger.setAttribute('tabindex', '1');

            const dropdown = document.createElement('div');
            dropdown.className = 'jobs-portal-select__dropdown';

            const list = document.createElement('div');
            list.className = 'jobs-portal-select__list';

            options.forEach((option) => {
                const optionEl = document.createElement('div');

                optionEl.className = 'jobs-portal-select__option';
                optionEl.dataset.value = option.value;
                optionEl.textContent = option.textContent;
                optionEl.setAttribute('tabindex', '1');

                if (option.value === select.value) {
                    optionEl.classList.add('active');
                }

                if (option.value === '0') {
                    optionEl.classList.add('default');
                }

                optionEl.addEventListener('click', (event) => {
                    event.stopPropagation();

                    select.value = option.value;
                    trigger.textContent = option.textContent;

                    list.querySelectorAll('.jobs-portal-select__option').forEach((el) => {
                        el.classList.remove('active');
                    });

                    optionEl.classList.add('active');

                    customSelect.classList.remove('is-open');

                    select.dispatchEvent(
                        new Event('change', {
                            bubbles: true,
                        }),
                    );
                });

                list.append(optionEl);
            });

            trigger.addEventListener('click', (event) => {
                event.stopPropagation();

                this.el.querySelectorAll('.jobs-portal-select').forEach((el) => {
                    if (el !== customSelect) {
                        el.classList.remove('is-open');
                    }
                });

                customSelect.classList.toggle('is-open');
            });

            dropdown.append(list);
            customSelect.append(trigger, dropdown);

            source.append(customSelect);
        });

        if (this.selectsClickBinded) return;

        this.selectsClickBinded = true;

        document.addEventListener('click', () => {
            this.el.querySelectorAll('.jobs-portal-select').forEach((select) => {
                select.classList.remove('is-open');
            });
        });
    }

    renameSelects() {
        const labels = {
            Category: 'Sector',
            'Work Type': 'Role type',
            Keywords: 'Search',
        };

        this.el.querySelectorAll('select option').forEach((option) => {
            if (labels[option.textContent]) {
                option.textContent = labels[option.textContent];
            }
        });
    }

    setupKeywordSearch() {
        const input = this.el.querySelector('#ja-keywords');

        if (!input || input.dataset.jobsPortalSearchReady) return;

        input.dataset.jobsPortalSearchReady = 'true';
        input.placeholder = 'Search';

        input.addEventListener('input', () => {
            clearTimeout(this.searchTimeout);

            this.searchTimeout = setTimeout(() => {
                const searchButton = this.el.querySelector('.ja-submit .ja-button');

                if (searchButton) {
                    searchButton.click();
                }
            }, 400);
        });
    }

    setupPager() {
        const pager = this.el.querySelector('.ja-pager');

        if (!pager || pager.dataset.jobsPortalPagerReady) return;

        pager.dataset.jobsPortalPagerReady = 'true';

        const pages = [...pager.querySelectorAll('.page, .current-page')];

        if (!pages.length) return;

        const pagesWrap = document.createElement('div');
        pagesWrap.className = 'ja-pager-pages';

        pages[0].before(pagesWrap);

        pages.forEach((page) => {
            pagesWrap.append(page);
        });
    }

    setupJobSectors() {
        this.el.querySelectorAll('.ja-job-list .job').forEach((job) => {
            job.classList.remove(
                'sector-aviation',
                'sector-aerospace',
                'sector-engineering',
                'sector-energy',
            );

            const sector = job.querySelector('.classifications li[data-id="20380"]');

            if (!sector) return;

            const value = sector.textContent.trim().toLowerCase();

            if (value === 'aviation') {
                job.classList.add('sector-aviation');
            }

            if (value === 'aerospace & defence') {
                job.classList.add('sector-aerospace');
            }

            if (value === 'engineering') {
                job.classList.add('sector-engineering');
            }

            if (value === 'energy') {
                job.classList.add('sector-energy');
            }
        });
    }

    setupApplicationFile() {
        const resume = this.el.querySelector('#CandidateResume');

        if (!resume) return;

        const field = resume.closest('.ja-field');

        if (!field) return;

        field.setAttribute('data-custom-file', '');

        this.customFile.init();
    }

    setupLoader() {
        if (this.loaderReady) return;

        const hasContent = this.el.querySelector(
            '.ja-job-search, .ja-job-list-container, .ja-job-details, .ja-job-apply, .ja-application-submitted, .no-jobs-content'
        );

        if (!hasContent) return;

        this.loaderReady = true;

        setTimeout(() => {
            this.el.classList.remove('is-loading');
        }, 1500);
    }
}